"use client";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const musicalQuotes = [
  {
    quote: "Muzica este arta de a gândi cu sunete.",
    author: "Jules Combarieu",
  },
  {
    quote: "Muzica dă suflet la lucrurile cele mai neînsuflețite.",
    author: "Charles Darwin",
  },
  {
    quote: "Muzica este limbajul sufletului.",
    author: "Friedrich Nietzsche",
  },
  {
    quote: "Fără muzică, viața ar fi o greșeală.",
    author: "Friedrich Nietzsche",
  },
  {
    quote: "Muzica este cea mai puternică formă de magie.",
    author: "Marin Sorescu",
  },
  {
    quote: "Muzica este poezia aerului.",
    author: "Thomas Carlyle",
  },
];

const getSeedFromDate = () => {
  const d = new Date();
  // Returns a unique number for each day (e.g., 20240520)
  return (
    d.getFullYear() * 100000 +
    (d.getMonth() + 1) * 10000 +
    d.getDate() * 100 +
    d.getMinutes()
  );
};

export default function FunMusicalQuote() {
  const seed = getSeedFromDate();
  const randomIndex = seed % musicalQuotes.length;
  const currentQuote = musicalQuotes[randomIndex];

  return (
    <Box
      sx={{
        mt: 6,
        p: 3,
        borderRadius: 3,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: "divider",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontFamily: "var(--font-body)" }}>
        💭 În timp ce ești aici...
      </Typography>
      <Typography variant="body1" sx={{ fontStyle: "italic" }}>
        &ldquo;{currentQuote.quote}&rdquo; - {currentQuote.author}
      </Typography>
      <Typography variant="body2" sx={{ mt: 1 }}>
        Și noi credem că fiecare copil merită propria sa simfonie!
      </Typography>
    </Box>
  );
}
